// Import the public components directly
import JobListings from '../../public/JobListings';
import { ThemeProvider } from '../../../contexts/ThemeContext';

const Jobs = () => {
  return (
    <>
      {/* SEO Settings */}
      <meta name="robots" content="noindex, nofollow" />
      
      <ThemeProvider theme="candidate">
        <JobListings />
      </ThemeProvider>
    </>
  );
};

export default Jobs;